import { Link } from "react-router-dom";

const NewsComponent = () => {
  const newsItems = [
    {
      img: "/Home/1770105415086.jpg",
      title: "TCS and Nippon Express Group Announce Strategic Partnership",
      date: "03 February 2026",
      link: "/news-detail",
    },
    // {
    //   img: "/Home/HRStrategy.jpg",
    //   title: "Jazz CEO, Aamir Hafeez Ibrahim meets TCS Leadership",
    //   date: "14 February 2025",
    // },
    {
      img: "/Home/LUMSGroup1.jpg",
      title: "TCS C Suite Welcome Top Business School (LUMS) Future Leaders",
      date: "24th January 2026",
    },
    {
      img: "/Home/futureSummit1.jpg",
      title: "The Future Summit 9th Edition",
      date: " 5th November 2025",
    },
  ];

  return (
    <div>
      <div className="max-w-[85rem] mx-auto flex justify-between flex-col items-center lg:py-[5rem] md:py-[3rem] text-[#373737] sm:pt-[2rem] pt-[40px] pb-[3rem]">
        <h1 className="react-reveal font-bold sm:text-4xl text-3xl max-w-[23rem]">
          In The News
        </h1>
        <hr className="hr" />
        <div className="grid md:flex flex-wrap gap-6 justify-center mt-8 px-4">
          {newsItems.map((item, index) => {
            return (
              <div
                key={index}
                className="react-reveal flex flex-col flex-1 w-full max-w-[20rem] 
                           transition-all duration-300 hover:shadow-lg rounded-lg overflow-hidden
                           bg-white border border-gray-100"
              >
                <div className="relative w-full h-48">
                  {item.link ? (
                    <Link to={item.link} className="w-full h-full block">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="w-full h-full object-cover"
                      />
                    </Link>
                  ) : (
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="p-4 flex flex-col items-center">
                  <h2
                    className="font-bold text-lg md:text-xl mb-2 text-center 
                               line-clamp-2 hover:text-red-600 transition-colors"
                  >
                    {item.title}
                  </h2>
                  <p className="text-sm text-gray-600">{item.date}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NewsComponent;
